import styled from 'styled-components';
export const ContactsNameWrapper = styled.div.withConfig({
  displayName: "contacts__ContactsNameWrapper",
  componentId: "sc-17k2dp4-0"
})(["font-weight:600;& *:hover{text-decoration:none;}"]);
export const ContactsAvatarWrapper = styled.div.withConfig({
  displayName: "contacts__ContactsAvatarWrapper",
  componentId: "sc-17k2dp4-1"
})(["width:40px;height:40px;"]);
export const ContactsListWrapper = styled.div.withConfig({
  displayName: "contacts__ContactsListWrapper",
  componentId: "sc-17k2dp4-2"
})(["height:auto;overflow:auto;"]);